import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsAccountPageRedesignEnabled() {
  return useCbhFlag(CbhFeatureFlag.ENABLE_ACCOUNT_PAGE_REDESIGN, {
    defaultValue: false,
  });
}
